import { makeStyles } from "@material-ui/core";
import { color } from "../../assets/const/color";

export const useStyles = makeStyles(() => ({
  root: {
    marginTop: "20px",
    "& .MuiInputBase-root": {
      borderRadius: "40px !important",
    },
    "& .MuiPagination-ul": {
      justifyContent: "center",
    },
    "& .MuiPaginationItem-root.Mui-selected": {
      backgroundColor: color.lightGreen,
      color: color.white,
    },
    "& .MuiPaginationItem-root.Mui-selected:hover": {
      backgroundColor: color.lightGreen,
      color: color.white,
    },
    flexDirection: "row !important",
    justifyContent: "flex-end",
    alignItems: "center",
    "& .MuiOutlinedInput-input": {
      padding: "6px !important",
      paddingRight: "30px !important",
      paddingLeft: "15px !important",
    },
    "& .MuiButtonBase-root": {
      fontFamily: "inter !important",
    },
  },
}));
